module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starEmpty@3x-74caa686635c32c7bc96c60f46b004f8.png";